import { Button, ToggleButtonGroup } from "@mui/material";
import { useState } from "react";
import { useTranslations } from "use-intl";

import { ListToggleButton } from "@/components/ListToggleButton/ListToggleButton";
import { ReservationType } from "@/features/bookings/types/types";

import { reservationTypesLabels } from "./labels";

type Props = {
  value: ReservationType;
  onValueChange: (value: ReservationType) => void;
};

export const OrdersTypeList = ({ value, onValueChange }: Props) => {
  const t = useTranslations();
  const [currentReservationType, setCurrentReservationType] =
    useState<ReservationType>(value);

  return (
    <div className="relative w-full">
      <ToggleButtonGroup
        orientation="vertical"
        fullWidth
        exclusive
        size="small"
        color="primary"
        aria-label={t("bookingTypeOptionsLabel")}
      >
        {Object.values(ReservationType).map((reservationType) => (
          <ListToggleButton
            key={reservationType}
            value={reservationType}
            onChange={() => setCurrentReservationType(reservationType)}
            selected={currentReservationType === reservationType}
          >
            {t(reservationTypesLabels[reservationType])}
          </ListToggleButton>
        ))}
      </ToggleButtonGroup>

      <div className="mt-4">
        <Button
          fullWidth
          onClick={() => onValueChange(currentReservationType)}
          variant="contained"
          size="large"
        >
          {t("done")}
        </Button>
      </div>
    </div>
  );
};
